/* Auth / tenancy: login, sessão, troca de tenant e convites. */
import {
  acceptInviteInput,
  inviteInfo,
  loginInput,
  loginOutput,
  meOutput,
  type InviteInfo,
  type LoginInput,
  type LoginOutput,
  type MeOutput,
} from "@zapir/shared";
import { z } from "zod";
import { request } from "./core";

/* Tipos derivados que o shared nao reexporta por nome. */
type AcceptInviteInput = z.infer<typeof acceptInviteInput>;

export const authApi = {
  async login(input: LoginInput): Promise<LoginOutput> {
    const body = loginInput.parse(input);
    const out = await request("/auth/login", {
      method: "POST",
      body,
      schema: loginOutput,
      skipTenant: true,
      skipAuthRedirect: true,
    });
    return out;
  },

  async logout(): Promise<void> {
    try {
      await request("/auth/logout", { method: "POST", skipTenant: true, skipAuthRedirect: true });
    } catch {
      /* logout local sempre acontece */
    }
  },

  async me(): Promise<MeOutput> {
    return request("/me", { schema: meOutput });
  },

  async switchTenant(tenantId: string): Promise<LoginOutput> {
    return request("/auth/switch-tenant", {
      method: "POST",
      body: { tenantId },
      schema: loginOutput,
      skipTenant: true,
    });
  },

  /** Aceite de convite cria conta/vinculo e ja devolve sessao (doc 02 §3). */
  async acceptInvite(input: AcceptInviteInput): Promise<LoginOutput> {
    return request("/invites/accept", {
      method: "POST",
      body: acceptInviteInput.parse(input),
      schema: loginOutput,
      skipTenant: true,
      skipAuthRedirect: true,
    });
  },

  async inviteInfo(token: string): Promise<InviteInfo> {
    return request(`/invites/${encodeURIComponent(token)}`, {
      schema: inviteInfo,
      skipTenant: true,
      skipAuthRedirect: true,
    });
  },
};
